import script from "./MenuView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuView.vue?vue&type=script&lang=ts&setup=true"

import "./MenuView.vue?vue&type=style&index=0&id=2bbdb4a8&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbdb4a8"]])

export default __exports__